// src/features/executive/account/hooks/use-treatment-revenue.ts
import { useExecutiveQuery } from 'features/executive/shared/hooks/use-executive-query'
import AccountApi from 'api/executive/account.api'
import type {
  GetTreatmentRevenueParams,
  TreatmentRevenueResponse,
} from 'api/executive/executive.types'

export function useTreatmentRevenue() {
  return useExecutiveQuery<GetTreatmentRevenueParams, TreatmentRevenueResponse>(
    'account.treatment-revenue',
    AccountApi.getTreatmentRevenue,
    (f) => {
      if (!f.dateRange?.start || !f.dateRange?.end) return null
      return {
        dateFrom: f.dateRange.start,
        dateTo: f.dateRange.end,
        branchId: f.branchId ?? undefined,
        paymentType: f.paymentType ?? undefined,
      }
    }
  )
}
